export const colors = {
    black: '#2F2F2F',

    greenLighter: '#EAF4F2',
    greenLight: '#D5EAE5',
    greenLightContrast: '#C2E0D9',
    greenLightMedium: '#8FC7BA',
    greenMedium: '#68A092',
    greenPrimary: '#009878',

    grey: '#D2D3D2',
    greyLight: '#F0F0F0',
    greyLighter: '#F8F8F8',
    greyLightest: '#FBFBFB',
    greyMedium: '#A3A3A3',
    greyDark: '#666666',

    orangeHover: '#C13F02',
    primary: '#FF5200',
    red: '#BE0202',
    error: '#DF5B5B',
    errorLight: '#FEEDF0',

    white: '#FFFFFF',
};
